/*
  PageSpeed: every slick carousel measures the page when it starts, which forces the browser to re-lay-out the whole ~5,000-node page.
  Carousels now start on the visitor's first scroll, move, touch, key press or click, or 8 seconds after the page has loaded.
  Autoplay carousels begin playing on the first interaction. If something calls a slick method (next/previous, etc.) before a carousel
  has started, it is started on the spot first. Loaded with `defer` right after jQuery and slick.
*/
(function ($) {
  if (!$ || !$.fn || !$.fn.slick) { return; }
  var original = $.fn.slick;
  var pending = [];
  var playLater = [];
  var interacted = false;

  function startOne(item) {
    var $el = item.$el;
    if ($el.data('gwSlickDone')) { return; }
    $el.data('gwSlickDone', true);
    var opts = $.extend({}, item.opts);
    var wantsPlay = !!opts.autoplay;
    opts.autoplay = false;
    original.call($el, opts);
    if (wantsPlay) {
      if (interacted) {
        try { $el.slick('slickPlay'); } catch (e) {}
      } else {
        playLater.push($el);
      }
    }
  }

  function startAll() {
    var items = pending.splice(0);
    (function next() {
      var item = items.shift();
      if (!item) { return; }
      startOne(item);
      setTimeout(next, 0);
    })();
  }

  function onInteract() {
    if (interacted) { return; }
    interacted = true;
    startAll();
    playLater.splice(0).forEach(function ($el) {
      try { $el.slick('slickPlay'); } catch (e) {}
    });
  }

  ['scroll', 'mousemove', 'touchstart', 'keydown', 'click'].forEach(function (name) {
    window.addEventListener(name, onInteract, { once: true, passive: true });
  });
  window.addEventListener('load', function () { setTimeout(startAll, 800); });

  $.fn.slick = function () {
    var args = arguments;
    var first = args[0];
    var isInit = args.length === 0 || (first && typeof first === 'object');

    if (isInit) {
      return this.each(function () {
        var $el = $(this);
        if ($el.hasClass('slick-initialized') || $el.data('gwSlickDone')) { return; }
        var item = $el.data('gwSlickPending');
        if (item) {
          item.opts = first || {};
        } else {
          item = { $el: $el, opts: first || {} };
          $el.data('gwSlickPending', item);
          pending.push(item);
        }
      });
    }

    this.each(function () {
      var $el = $(this);
      var item = $el.data('gwSlickPending');
      if (item && !$el.data('gwSlickDone')) { startOne(item); }
    });
    return original.apply(this, args);
  };
})(window.jQuery);
